<template>
  <div class="versionlayout">
    <el-container>
      <el-main>
        <div class="div">
          <el-button type="primary" @click="addVersion">+&nbsp;新增</el-button>
        </div>
        <div class="div2">
          <div class="div2-br">
            <span>学段</span>
            <div class="btn">
              <el-radio-group v-model="stageId" @change="changeit">
                <el-radio-button size="small" :label="item.id"  v-for="(item,index ) in stages"  :key="index" >{{item.name}}</el-radio-button>
              </el-radio-group>
            </div>
          </div>
          <div class="div2-br">
            <span>科目</span>
            <div class="btn">
              <el-radio-group v-model="subjectId" @change="changeSubject">
                <el-radio-button size="small"  :label="item.id"  v-for="(item,index ) in subjects"  :key="index" >{{item.name}}</el-radio-button>
              </el-radio-group>
            </div>
          </div>
          <div class="div2-br">
            <span>模块</span>
            <div class="btn">
              <el-radio-group v-model="basicDocumentStatus" @change="changeSubject">
                <el-radio-button size="small"  label=0 >备课</el-radio-button>
                <el-radio-button v-if="stageId === 4" size="small"  label=1 >新高考</el-radio-button>
              </el-radio-group>
            </div>
          </div>
        </div>
        <el-table
          :data="tableData"
          :height="height"
          header-row-class-name="header-row-class-name"
          :default-sort = "{prop: 'id', order: 'descending'}"
          border
          style="width: 100%">
          <el-table-column
            sortable
            prop="id"
            label="ID号">
          </el-table-column>
          <el-table-column
            sortable
            prop="ordinal"
            label="排序号（可编辑）">
          </el-table-column>
          <el-table-column
            prop="name"
            label="版本名">
          </el-table-column>

          <el-table-column
            label="状态">
            <template slot-scope="scope">
              <span v-if="scope.row.used === true" style="color: #00ff00"> 启用</span>
              <span v-if="scope.row.used === false" style="color: #ff0000">禁用</span>
            </template>
          </el-table-column>

          <el-table-column
            fixed="right"
            label="操作">
            <template slot-scope="scope">
              <el-button  type="text" size="small" @click="editVersion(scope.row.id,scope.row)">编辑</el-button>
              <el-button  type="text" size="small" @click="disable(scope.row.id)" v-if="scope.row.used == true">禁用</el-button>
              <el-button  type="text" size="small" @click="enable(scope.row.id)" v-if="scope.row.used == false">启用</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 编辑框 -->
        <edit-dialog  v-model="versionDialogVisible" :stageId="stageId" :subjectId="subjectId" :basicDocumentStatus="basicDocumentStatus" :rowData="rowData" :id="id" @success="editSuccess"></edit-dialog>
      </el-main>
    </el-container>
  </div>
</template>
<script type="text/babel">
import editDialog from './edit-dialog'
import versionService from '@/service/versionService'
import commonService from '@/service/commonService'
export default {
  components: {
    editDialog: editDialog
  },
  name: 'versionManage',
  data () {
    return {
      id: 0,
      height: this.SysConstant.winHeight - 360,
      rowData: {},
      stageId: 0,
      subjectId: 0,
      stages: [],
      subjects: [],
      versionDialogVisible: false,
      tableData: [],
      basicDocumentStatus: 0
    }
  },
  async mounted () {
    // 查询
    await this.fetchLearnData()
    await this.fetchClassData()
    await this.fetchData()
  },
  async created () {

  },

  methods: {
    // 启用
    async enable (id) {
      try {
        await versionService.enableOrDisable({id: id, use: true})
        this.$message.success(this.SysConstant.success)
        this.fetchData()
      } catch (e) {
        this.$message.error(e && e.msg)
      }
    },
    // 禁用
    async disable (id) {
      this.$confirm('此操作将禁用该版本, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        await versionService.enableOrDisable({id: id, use: false})
        this.$message.success(this.SysConstant.success)
        this.fetchData()
      }).catch((e) => {
       // this.$message.error(e && e.msg)
      })
    },
    async changeit () {
      await this.fetchClassData()
      await this.fetchData()
    },
    async changeSubject () {
      await this.fetchData()
    },
    /* 获取学段数据 */
    async fetchLearnData () {
      try {
        let data = await commonService.fetchCommonStage()
        if (data) {
          this.stageId = data[1].id
          this.stages = data
        } else {
          this.stages = []
          this.stageId = 0
        }
      } catch (e) {
        this.$message.error(e && e.msg)
      }
    },
    /* 获取科目数据 */
    async fetchClassData () {
      try {
        let data = await commonService.fetchCommonSubject(parseInt(this.stageId))
        if (data && data.length > 0) {
          this.subjectId = data[0].id
          this.subjects = data
        } else {
          this.subjectId = 0
          this.subjects = []
        }
      } catch (e) {
        this.$message.error(e && e.msg)
      }
    },
    async fetchData () {
      try {
        let data = await versionService.fetchData({id: this.subjectId, basicDocumentStatus: this.basicDocumentStatus, specifyModuleId: ''})
        if (data) {
          this.tableData = data
        } else {
          this.tableData = []
        }
      } catch (e) {
        this.$message.error(e && e.msg)
      }
    },
    addVersion () {
      this.id = 0
      this.versionDialogVisible = true
    },
    editVersion (id, row) {
      this.id = id
      this.rowData = row
      this.versionDialogVisible = true
    },
    editSuccess () {
      this.id = 0
      this.rowData = {}
      this.versionDialogVisible = false
      this.$message.success(this.SysConstant.success)
      this.fetchData()
    }
  }
}
</script>
<style scoped>
  .versionlayout .clear{
    clear:both;
  }

  .versionlayout .div .el-button{
    background-color: #00aaff;
    color:#fff;

    margin:10px;
    float:left;
  }

  .versionlayout .div2 .el-button{
    margin:10px;
  }
  .versionlayout .div2 .el-button:hover{
    background-color: #00aaff;
    color:#fff;
  }
  .versionlayout .div2 .active{
    background-color: #00aaff;
    color:#fff;
  }

  .versionlayout .div2{
    padding:5px 0;
    margin:5px 0;
    background-color: #ffffff;
    color: #333;
    overflow: hidden;
  }

  .versionlayout .div2 .div2-br{
    overflow: hidden;
  }

  .versionlayout .div2 span{
    height:60px;
    line-height:60px;
    margin:0 20px;
    float:left;
  }
  .versionlayout .div2 .btn{
    width:80%;
    float:left;
  }

</style>
<style type="text/css">
  .versionlayout .div2 .el-radio-button{
    margin:10px 10px;
    border:none !important;
    border-radius:4px !important;
  }
  .versionlayout .el-radio-button__inner{
    border: 1px solid #dcdfe6;
  }
  .versionlayout .div{
    background-color: #ffffff;
    color: #333;
    line-height: 60px;
    height:60px;
    margin-top:-10px;
    margin-bottom:5px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/layout/version-manage/index.vue